import styled from 'styled-components';
import Button from './Button';
import { PiCrownSimpleFill } from "react-icons/pi";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.xl};
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const Icon = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.success};
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

const Title = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.success};
`;

const Message = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.text};
  opacity: 0.9;
`;

const SubscriptionSuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <Icon>
          <PiCrownSimpleFill />
        </Icon>
        <Title>Welcome to Premium!</Title>
        <Message>
          Thank you for subscribing. Your account has been upgraded with unlimited storage and all premium features.
        </Message>
        <Button onClick={onClose}>
          Start Using Premium
        </Button>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SubscriptionSuccessModal; 